import styled from 'styled-components';
import GatekeepingListHeader from './component';

export default styled(GatekeepingListHeader)``;
